/**
* ...
* @author DefaultUser (Tools -> Custom Arguments...)
*/
/**
 * package: com.inq.ui
 * class: Image
 * @extends com.inq.ui.Container 
 * @constructor
 */
com.inq.ui.Image = function(_id) {
	com.inq.ui.Container.call(this,_id);
	if(this._div != null) {
		this._div.alt = "";
		this._div.setAttribute("aria-hidden", "true");
	}
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.Image, "com.inq.ui.Image");

/**
 * setSrc
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * override private function setSrc(val:Dynamic):Dynamic
 * @override
 * @private
 * @this com.inq.ui.Image
 * @param {null}  val 
 * @return {null}
 */
com.inq.ui.Image.prototype.setSrc = function(val) {
	haxe.Log.trace("Image.setSrc: " + Std.string(val),{ fileName : "Image.hx", lineNumber : 19, className : "com.inq.ui.Image", methodName : "setSrc"});
	if(this._div != null) {
		this.src = val;
		if(this.src == null || this.src == "") return;
		
		this._backgroundImage = this.getNewImage();
		this._backgroundImage.onload = $bind(this,this.whenLoaded);
		this._backgroundImage.src = this.src;

		// CL
		this._backgroundImage.alt = "";
		this._backgroundImage.setAttribute("aria-hidden", "true");
		this._backgroundImage.setAttribute("tabindex", "-1");
	}
};

/** @type {js.Image} */
com.inq.ui.Image.prototype._img = null;
/** @type {com.inq.ui.Image} */
com.inq.ui.Image.prototype.__class__ = com.inq.ui.Image;
